module.exports = __webpack_public_path__ + "img/widget-mockup.6e1f776d.png";